import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import AdminLayout from '../../components/admin/AdminLayout'
import { useAuth } from '../../context/AuthContext'
import { API_BASE } from '../../utils/api'

interface PropertyType {
    _id: string;
    name: string;
    slug?: string;
    isActive?: boolean;
}

export default function AdminPropertyTypes() {
    const navigate = useNavigate()
    const { token } = useAuth()
    const [types, setTypes] = useState<PropertyType[]>([])
    const [loading, setLoading] = useState(true)

    const fetchData = async () => {
        setLoading(true)
        try {
            const res = await fetch(`${API_BASE}/property-types`)
            const data = await res.json()
            if (Array.isArray(data)) setTypes(data)
        } catch (err) {
            console.error(err)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => { fetchData() }, [])

    const handleDelete = async (id: string) => {
        if (!window.confirm('Delete this property type?')) return
        try {
            const res = await fetch(`${API_BASE}/property-types/${id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } })
            const data = await res.json()
            if (!res.ok) {
                return alert(data.message || 'Failed to delete')
            }
            fetchData()
        } catch (err) { 
            console.error(err)
            alert('An error occurred while deleting')
        }
    }

    return (
        <AdminLayout>
            <div className="flex items-center justify-between mb-8">
                <div>
                     <h1 className="text-3xl font-bold text-[#05144b] mb-2 leading-none">Property Categories</h1>
                    <p className="text-[#05144b] font-semibold text-[14px]">Manage high-level property classification protocols.</p>
                </div>
                <div>
                    <button className="px-6 py-3 bg-white border-2 border-[#05144b] text-[#05144b] hover:bg-blue-50 rounded-md font-bold transition-all shadow-md active:scale-95" onClick={() => navigate('/admin-add-property-type')}>
                        <i className="fa-solid fa-plus-circle me-2"></i> Add Property Type
                    </button>
                </div>
            </div>

            <div className="bg-white rounded-md border p-4">
                {loading ? (
                    <div className="py-20 text-center">Loading...</div>
                ) : types.length === 0 ? (
                    <div className="py-20 text-center">No property types found.</div>
                ) : (
                    <table className="w-full">
                        <thead>
                            <tr>
                                 <th className="text-left p-4 font-bold text-[#05144b]">Category Name</th>
                                <th className="text-left p-4 font-bold text-[#05144b]">URL Slug</th>
                                <th className="text-right p-4 font-bold text-[#05144b]">Operational Hub</th>
                            </tr>
                        </thead>
                        <tbody>
                            {types.map(t => (
                                <tr key={t._id} className="border-t">
                                     <td className="p-4 font-bold text-[#05144b]">{t.name}</td>
                                    <td className="p-4 text-[#05144b]/60 font-semibold">{t.slug}</td>
                                    <td className="p-3 text-right">
                                        <button className="px-3 py-1 bg-white border border-[#05144b] text-[#05144b] hover:bg-blue-50 rounded mr-2 transition-all shadow-sm active:scale-95" onClick={() => navigate(`/admin-edit-property-type/${t._id}`)}>Edit</button>
                                         <button className="px-3 py-1 bg-white border-2 border-slate-50 text-rose-600 hover:bg-rose-600 hover:text-white rounded transition-all shadow-sm active:scale-95" onClick={() => handleDelete(t._id)}>Delete</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </AdminLayout>
    )
}
